<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <svg-icon src="./assets/images/icons/close.svg"></svg-icon>
    </button>
</div>
<div class="modal-body text-left">
    <div class="text-center">
        <h4 class="font-weight-semibold mb-3 mb-md-4">Are you sure you want to change the status?</h4>
    </div>
    <div *ngIf="status == 'reject'" class="activreject">
        <form [formGroup]="approvalForm" (ngSubmit)="onSubmit()">
            <div class="form-group">
                <label for="comment">Reason:</label>
                <textarea id="comment" formControlName="comment" class="form-control"></textarea>
                <small class="text-danger"
                    *ngIf="approvalForm.get('comment')?.invalid && (approvalForm.get('comment')?.dirty || approvalForm.get('comment')?.touched)">
                    <div *ngIf="approvalForm.get('comment')?.errors?.required">Reason is required.</div>
            </small>
            </div>
            
            
            
            <button class="btn btn-primary btn-sm" type="submit" [disabled]="approvalForm.invalid">Submit</button>
        </form>
    </div>
    <div *ngIf="status != 'reject'">
        <div class="d-flex align-items-center column-gap-3 mt-3 mt-md-4 mt-lg-5 justify-content-center">
            <button class="btn btn-clear w-50" type="button" (click)="changeStatusNo()">No</button>
            <button class="btn btn-primary w-50" type="button" (click)="changeStatusYes()">Yes</button>
        </div>
    </div>
</div>